module.exports = __webpack_public_path__ + "media/images/dk_file-0fd4174966a248db94602b269148e575.png";